import { Injectable } from '@angular/core';
import { Subject ,  BehaviorSubject } from 'rxjs';
import { Drawing } from '../../../../../viewmodels/idms/drawing';

@Injectable()
export class DrawingPreviewGalleryService {
  drawingsLoaded = new BehaviorSubject<Drawing[]>([]);
  drawingViewRequested = new Subject<string>();

  constructor() { }

  loadDrawings(drawings: Drawing[]) {
    this.drawingsLoaded.next(drawings);
  }

  viewDrawing(mediaItemDetailsId: string) {
    this.drawingViewRequested.next(mediaItemDetailsId);
  }
}
